import classNames from "classnames";
import React from "react";

export type HeaderColumnCount = undefined | 1 | 2 | 3 | 4;
export type HeaderColumnFixedWidth = undefined | "md" | "lg";

interface HeaderColumnMenuProps {
   className?: string,
   columnCount?: HeaderColumnCount,
   fixedWidth?: HeaderColumnFixedWidth,
}

export const HeaderColumnMenu: React.FC<HeaderColumnMenuProps> = ({ children, className, columnCount = 1, fixedWidth }) => {
   const columns = new Array<ReturnType<typeof React.Children.toArray>>();
   const items = React.Children.toArray(children);
   if (columnCount && columnCount > 1 && items.length > 1) {
      const itemsPerColumn = Math.ceil((items.length - 1) / columnCount); //push single element into last column instead      
      for (let i = 0; i < columnCount; i++) {
         columns[i] = items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn);
      }
      for (let leftOverIndex = itemsPerColumn * columnCount; leftOverIndex < items.length; leftOverIndex++) {
         columns[columnCount - 1].push(items[leftOverIndex]);
      }
   }
   else {
      columns[0] = items;
   }
   return (
      <div className={classNames("header-columns", `header-columns-${columnCount || 1}`, className)}>
         {columns.map((column, cIndex) => (
            <div className={classNames("header-column", { [`header-column-fixed-${fixedWidth}`]: !!fixedWidth })} key={cIndex}>
               {column.map((item, iIndex) => item)}
            </div>
         ))}
      </div>
   );
}